// This directive shows a graph of a single value from BoxCaster stats. Many options are
// configurable via attributes.
angular.module('app.directives').directive('appBoxcasterSingleValueGraph', $location =>
    ({
        require: '^^appBoxcasterGraph',
        restrict: 'E',
        scope: {
            statsData: '=',
            target: '@',
            renderer: '@',
            min: '@',
            max: '@',
            color: '@'
        },
        controller($scope) {
            $scope.data = [];
            $scope.options = {
                renderer: $scope.renderer,
                height: 40,
                min: $scope.min,
                max: $scope.max
            };
            $scope.series = [{
                data: $scope.data,
                color: $scope.color
            }];
            return $scope.$watch('statsData', function(newval, oldval) {
                if ((newval != null) && (newval[$scope.target] != null)) {
                    $scope.data.length = 0;
                    return Array.prototype.push.apply($scope.data, _.map(newval[$scope.target], function(v, k) {
                        if (v < 0) {
                            v = null;
                        }
                        return { x: parseInt(k), y: v };
                    }).sort((a, b) => a.x - b.x));
                }
            });
        },
        link(scope, element, attrs, appBoxcasterGraph) {
            return appBoxcasterGraph.registerGraphWidthCallback(newWidth =>
                scope.$apply(() => scope.options.width = newWidth)
            );
        },
        template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
    }));


// WEBPACK FOOTER //
// ./directives/boxcaster_single_value_graph.js